class BarbaraProductGallery extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.addEventListener('slideshow:select', () => this.updatePin(), options);
    this.addEventListener('barbara:media-change', () => this.updatePin(), options);
    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-be-pinterest]')) this.updatePin();
    }, options);
    this.addEventListener('auxclick', () => this.updatePin(), options);
    this.observer = new MutationObserver(() => this.updatePin());
    this.observer.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
    this.resizeObserver = new ResizeObserver(() => this.positionArrows());
    const slideshow = this.querySelector('slideshow-component');
    if (slideshow) this.resizeObserver.observe(slideshow);
    this.addEventListener('load', () => this.positionArrows(), { ...options, capture: true });
    window.addEventListener('resize', () => this.positionArrows(), options);
    this.updatePin();
    this.formatFacts();
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    this.resizeObserver?.disconnect();
    cancelAnimationFrame(this.arrowFrame);
  }
  formatFacts() {
    const details = this.closest('.product-information')?.querySelector('.product-details');
    const fioreSummary = details?.querySelector('.fiore-product-preview__facts');
    const summary = fioreSummary || [...(details?.querySelectorAll('p') || [])].find(element => element.querySelector('strong') && /EU\s+\d/.test(element.textContent) && element.textContent.split('·').length === 3);
    const disclosure = details?.querySelector('.be-product-disclosure');
    if (!summary || !disclosure || summary.dataset.beProductFacts) return;
    summary.dataset.beProductFacts = 'true';
    const labels = summary.textContent.split('·').map(label => label.trim());
    if (!fioreSummary && this.dataset.languageLabel) labels.splice(2, 0, this.dataset.languageLabel);
    summary.replaceChildren(...labels.map(label => {
      const item = document.createElement('span');
      item.textContent = label;
      return item;
    }));
    disclosure.before(summary);
    const overview = this.closest('.shopify-section')?.querySelector('[data-be-product-overview]');
    if (overview) summary.after(overview);
  }
  positionArrows() {
    cancelAnimationFrame(this.arrowFrame);
    this.arrowFrame = requestAnimationFrame(() => {
      const root = this.querySelector('slideshow-component');
      if (!root) return;
      const viewport = root.querySelector('slideshow-container');
      const active = root.querySelector('slideshow-slide[aria-hidden="false"]') || root.querySelector('slideshow-slide');
      const reference = active?.querySelector('.product-media-constraint-wrapper');
      if (!viewport || !reference) return;
      // The slides translate while navigating. Anchor controls to the stationary
      // viewport and active frame width, never to a moving slide's left/right edge.
      const outer = root.getBoundingClientRect();
      const box = viewport.getBoundingClientRect();
      const width = Math.min(box.width, reference.getBoundingClientRect().width);
      if (width < 1 || box.height < 1) return;
      const inset = (box.width - width) / 2;
      root.style.setProperty('--be-arrow-y', (box.top - outer.top + box.height / 2 - 22) + 'px');
      root.style.setProperty('--be-arrow-left', Math.max(0, box.left - outer.left + inset - 48) + 'px');
      root.style.setProperty('--be-arrow-right', Math.max(0, outer.right - box.right + inset - 48) + 'px');
    });
  }
  updatePin() {
    this.positionArrows();
    const link = this.querySelector('[data-be-pinterest]');
    const slideshow = this.querySelector('slideshow-component');
    const slides = [...(slideshow?.querySelectorAll('slideshow-slide') || [])];
    const counter = Number(slideshow?.querySelector('[ref="current"]')?.textContent);
    const slide = slides[counter - 1] || this.querySelector('slideshow-slide[aria-hidden="false"]') || slides[0];
    const image = slide?.querySelector('barbara-media-tabs [role="tabpanel"]:not([hidden]) img') || slide?.querySelector('.product-media__image');
    if (!link) return;
    link.parentElement.hidden = !image;
    if (!image) return;
    const media = new URL(image.getAttribute('data_max_resolution') || image.getAttribute('src'), location.origin);
    media.searchParams.set('width', '1920');
    const destination = new URL('https://www.pinterest.com/pin/create/button/');
    destination.searchParams.set('url', link.dataset.productUrl);
    destination.searchParams.set('media', media.href);
    destination.searchParams.set('description', link.dataset.description);
    link.href = destination.href;
  }
}
if (!customElements.get('barbara-product-gallery')) customElements.define('barbara-product-gallery', BarbaraProductGallery);
